const StringUtilities = require('./string-utilities')

export const getFixedRandomIdx = id => (StringUtilities.hashCode(id) || 0) % 6

export const getUserPlaceholder = ({ userId }) => {
  const idx = getFixedRandomIdx(userId)
  return `https://statics.fishfriender.com/statics/fisherman/fisherman_${idx}.png`
}

export const getEmptyImage = ({ id }) => {
  const idx = getFixedRandomIdx(id)
  return `https://statics.fishfriender.com/statics/fisherman/fisherman_${idx}.png`
}
